import React, {Fragment} from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";

import Button from "@mui/material/Button";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import SvgIcon from "@mui/material/SvgIcon";

import {
  setLookOverlayOpened,
  setLookPageOpened,
} from "../../../actions/lookFunctions";
import {LOOK_OVERLAYS} from "../core/constants";
import {IS_PRODUCT_JOURNEY} from "../../../config";
import COLOR_THEMES from "../../../colorThemes";

import {LookExitIcon} from "../../common/icons";
import WithSavePostMessage from "../hocs/withSavePostMessage";
import WithExitPostMessage from "../hocs/withExitPostMessage";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS, PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../analytics";
import {goToFabricatorUrl, isIframe} from "../../../misc/helpers";


const LookOverlayQuestionButtons = (props) => {

  const {activeTheme, lookOverlayOpened, setLookOverlayOpened, setLookPageOpened, hideOverlay, userIsLoggedIn,
    fabricatorData} = props;

  const isLixil = isIframe() && fabricatorData.isLixil;

  const closePopup = () => {
    hideOverlay(() => {
      setLookOverlayOpened("");
    })
  }

  const leaveButtonClick = (exitPostMessage) => {
    const analyticsLabel = IS_PRODUCT_JOURNEY
      ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.productOverlayLeave
      : LOOK_JOURNEY_ANALYTIC_EVENTS.lookOverlayLeave;
    Analytics.sendClickEvent(analyticsLabel);

    closePopup(hideOverlay);
    if (isLixil) {
      exitPostMessage();
    } else if (fabricatorData.websiteUrl) {
      goToFabricatorUrl(fabricatorData.websiteUrl);
    }
  }

  const saveButtonClick = (savePostMessage) => {
    const analyticsLabel = IS_PRODUCT_JOURNEY
      ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.productOverlaySave
      : LOOK_JOURNEY_ANALYTIC_EVENTS.lookOverlaySave;
    Analytics.sendClickEvent(analyticsLabel);

    if (userIsLoggedIn) {
      closePopup(hideOverlay);
      setLookPageOpened("");
      savePostMessage();
    } else {
      setLookOverlayOpened(isLixil ? LOOK_OVERLAYS.questionLogin : LOOK_OVERLAYS.leadCapture);
    }
    // history.push(ROUTES.login); // not necessary
  }

  const getButtons = () => {
    switch (lookOverlayOpened) {
      case LOOK_OVERLAYS.exit:
      case LOOK_OVERLAYS.print: {
        return (
          <Fragment>
            {lookOverlayOpened === LOOK_OVERLAYS.exit ? (
              <WithExitPostMessage>
                {(exitPostMessage) => (
                  <Button className={"look-button look-button--white"}
                          endIcon={(
                            <SvgIcon>
                              <LookExitIcon color={COLOR_THEMES[activeTheme].primary} />
                            </SvgIcon>
                          )}
                          onClick={() => leaveButtonClick(exitPostMessage)}>
                    <FormattedMessage id="buttons.leave"/>
                  </Button>
                )}
              </WithExitPostMessage>
            ) : null}
            {!isLixil && lookOverlayOpened === LOOK_OVERLAYS.exit ? null : (
              <WithSavePostMessage>
                {(savePostMessage) => (
                  <Button className={"look-button look-button--white"}
                          endIcon={<SaveIcon/>}
                          onClick={() => saveButtonClick(savePostMessage)}>
                    <FormattedMessage id="buttons.save"/>
                  </Button>
                )}
              </WithSavePostMessage>
            )}
            <Button className={"look-button look-button--primary"}
                    endIcon={<CloseIcon/>}
                    onClick={closePopup}>
              <FormattedMessage id="buttons.cancel"/>
            </Button>
          </Fragment>
        )
      }
    }
    return null
  }

  return (
    <div className="look-question__buttons">
      {getButtons()}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {lookOverlayOpened} = store.lookState;
  const {activeTheme} = store.serverState;
  const {userIsLoggedIn} = store.userState;
  const fabricatorData = store.fabricatorState;

  return {
    lookOverlayOpened,
    activeTheme,
    userIsLoggedIn,
    fabricatorData,
  };
};

const mapDispatchToProps = {
  setLookOverlayOpened,
  setLookPageOpened,
};

export default connect(mapStateToProps, mapDispatchToProps)(LookOverlayQuestionButtons)
